"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitter = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function Twitter(_a) {
  var children = _a.children,
      props = tslib_1.__rest(_a, ["children"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    d: "M22.0635 7.163C21.5475 7.85135 20.9237 8.4518 20.2163 8.94117C20.2163 9.12099 20.2163 9.3008 20.2163 9.4906C20.222 12.756 18.9176 15.8871 16.5957 18.182C14.2737 20.4769 11.1284 21.7435 7.86489 21.698C5.97815 21.7043 4.11558 21.2735 2.42307 20.4393C2.33181 20.3995 2.27295 20.3092 2.2733 20.2096V20.0997C2.2733 19.9562 2.38953 19.8399 2.53291 19.8399C4.38752 19.7788 6.17597 19.1358 7.64522 18.0018C5.96654 17.968 4.45615 16.9736 3.76106 15.4445C3.72595 15.361 3.73688 15.2652 3.78991 15.1917C3.84293 15.1183 3.93038 15.0778 4.02067 15.0848C4.53086 15.1361 5.04615 15.0886 5.53839 14.945C3.68526 14.5603 2.29285 13.0219 2.09357 11.1389C2.08649 11.0486 2.12697 10.9611 2.20039 10.908C2.2738 10.855 2.36955 10.844 2.45303 10.8792C2.95033 11.0986 3.48716 11.2142 4.03066 11.2188C2.40688 10.1531 1.70552 8.12594 2.32323 6.28391C2.38699 6.10491 2.54018 5.97269 2.7265 5.93581C2.91282 5.89894 3.10479 5.96286 3.23186 6.10409C5.42304 8.43617 8.43377 9.82584 11.6292 9.9801C11.5474 9.65349 11.5071 9.31784 11.5094 8.98113C11.5393 7.21558 12.6317 5.64279 14.2752 4.99908C15.9187 4.35537 17.7881 4.76815 19.0081 6.04415C19.8398 5.88572 20.6437 5.60638 21.3945 5.21501C21.4495 5.18067 21.5193 5.18067 21.5743 5.21501C21.6086 5.27003 21.6086 5.3398 21.5743 5.39482C21.2106 6.22757 20.5963 6.92602 19.8169 7.39277C20.4994 7.31362 21.1699 7.15263 21.8139 6.91326C21.8681 6.87635 21.9394 6.87635 21.9936 6.91326C22.0391 6.93404 22.073 6.97379 22.0865 7.02191C22.1 7.07003 22.0916 7.12164 22.0635 7.163Z",
    fill: "currentColor"
  }));
}

exports.Twitter = Twitter;